<template>
    <div class="bg-white pa-4 rounded-lg h-100 overflow-y-auto">
        <v-col md="11" lg="10" class="mx-auto">
            <v-row class="px-4 pt-4" align="center">
                <v-col cols="auto" class="pe-3">
                    <v-img :src="plugin.icon" width="62" height="62"></v-img>
                </v-col>
                <v-col>
                    <h3 class="mb-2">{{plugin.name}}</h3>
                    <p class="text-small mb-0"><v-icon size="15" class="me-1 text-primary">icon-relatedarticles</v-icon> دسته بندی: <span class="font-weight-bold">{{categoryItems.find(x => x.id == plugin.category).name}}</span></p>
                    <p class="text-small mb-1 mt-2 text-error" v-if="!plugin.accessConfig">این افزونه در پلن خریداری شده شما پشتیبانی نمی شود</p>
                </v-col>
            </v-row>
            <v-tabs v-model="activeComponent" class="mt-6 mb-3" color="secondary">
                <v-tab v-for="item in headerButtons" :value="item.link">{{item.title}}</v-tab>
            </v-tabs>
            <v-tabs-window v-model="activeComponent">
                <v-tabs-window-item value="config">
                    <config :plugin="plugin"></config>
                </v-tabs-window-item>
                <v-tabs-window-item value="informations">
                    <informations :plugin="plugin"></informations>
                </v-tabs-window-item>
                <v-tabs-window-item value="permissions">
                    <permissions :plugin="plugin"></permissions>
                </v-tabs-window-item>
            </v-tabs-window>
        </v-col>
    </div>
</template>
<script>
import pluginsSearchBox from '@/variables/pluginsSearchBox';
import config from '@/components/plugins/config.vue';
import informations from '@/components/plugins/informations.vue';
import permissions from '@/components/plugins/permissions.vue';
export default {
    title: "اطلاعات افزونه",
    components: {
        config,
        informations,
        permissions
    },
    validate(context) {
      return context.auth.user.full_admin;
    },
    data() {
        return {
            loading: false,
            headerButtons: [
                {
                    title: "جزئیات",
                    link: "informations",
                },
                {
                    title: "دسترسی ها",
                    link: "permissions",
                },
            ],
            activeComponent: 'informations',
            plugin: pluginsSearchBox().find(x => x.slug == this.$route.params.slug),
            categoryItems: [
                {
                    id: false,
                    name: 'همه دسته بندی ها',
                },
                {
                    id: 1,
                    name: 'ویپ',
                },
                {
                    id: 2,
                    name: 'پیامک',
                },
                {
                    id: 3,
                    name: 'احراز هویت',
                },
                {
                    id: 4,
                    name: 'چت آنلاین'
                }
            ]
        };
    },
    created() {
      if (this.plugin.accessConfig)
          this.headerButtons.push({
              title: "پیکربندی",
              link: "config",
          });
    },
};
</script>
